export { ConfirmDialogComponent } from './confirm-dialog.component';
export { AlertDialogComponent } from './alert-dialog.component';
export { MessageDialogComponent } from './message-dialog.component';

export { DialogsModule } from './dialogs.module';
